import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team-style-two',
  templateUrl: './team-style-two.component.html',
  styleUrls: ['./team-style-two.component.scss']
})
export class TeamStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
